import React from "react";
import "./style.css";

const MainPageSpinner = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100">
      <div className="main-page-spinner spinner-border mb-4" role="status"></div>
    </div>
  );
};

export default MainPageSpinner;



// WEBPACK FOOTER //
// ./src/components/MainPage/MainPageSpinner/MainPageSpinner.jsx